import { upCase } from "@utility/utilityFunctions";

export default function warehouseLabel(warehouseId: string) {
  return upCase(warehouseId);
}
